
import * as modals from "../../../lib/modals";
import Component from "vue-class-component";
import { getModule } from "vuex-module-decorators";
import ManifestModule from "@/store/modules/barcodeSystem/manifest";
import ModalMixin from "./mixin";
import ManifestHeader from "@/components/barcodeSystem/manifest/ManifestHeader.vue";
import ManifestDetailTable from "@/components/barcodeSystem/manifest/ManifestDetailTable.vue";
import { ManifestResource } from "@/models/api/barcodeSystem/manifests/get";
import notifications from "@/lib/notifications";

const manifestModuleState = getModule(ManifestModule);

@Component({
  name: modals.manifestViewModal,
  components: {
    ManifestHeader,
    ManifestDetailTable
  }
})
export default class ManifestViewModal extends ModalMixin {
  loadingComplete: boolean = false;
  saving: boolean = false;

  async load() {
    this.loadingComplete = false;
    this.show();
    if (this.modalData.new){
      manifestModuleState.startNew();
    }
    else {
      try {
        await manifestModuleState.loadManifest(this.selectedItem.id);
        await manifestModuleState.loadManifestDetails(this.selectedItem.id);
      } catch (ex) {
        notifications.error("Failed to load manifest", "Failed to load manifest.", ex);
        this.hideModal();
      }
    }
    this.loadingComplete = true;
  }

  get orderCount() : number
  {
    if(manifestModuleState.currentManifestDetails)
      return manifestModuleState.currentManifestDetails.length;
    return 0
  }

  get currentManifest() : ManifestResource
  {
    return manifestModuleState.currentManifest;
  }

  async hideManifest(){
    if(this.currentManifest)
    {
      try {
        await manifestModuleState.hideManifest(this.currentManifest);
        notifications.success("Manifest Removed", "Manifest successfully removed.");
        await this.reloadManifest();
      } catch (error) {
        notifications.error(
          "Manifest Remove Failed",
          error.response.data.message
        );
      }  
    }
  }  
  
  async restoreManifest(){
    if(this.currentManifest)
    {
      try {
        await manifestModuleState.restoreManifest(this.currentManifest);
        notifications.success("Manifest Restored", "Manifest successfully restored.");
        await this.reloadManifest();
      } catch (error) {
        notifications.error(
          "Manifest Restore Failed",
          error.response.data.message
        );
      }  
    }
  }

  async reloadManifest(){
    this.loadingComplete = false;
    try {
      await manifestModuleState.reloadManifest();
      await manifestModuleState.loadManifestDetails(this.currentManifest.id);
    } catch (ex) {
      notifications.error("Failed to load manifest", "Failed to load manifest.", ex);
      this.hideModal();
    }
    this.loadingComplete = true;
  }

  async saveManifest(){
    this.saving = true;
    let saved = false;
    try {
      await manifestModuleState.saveManifest();
      saved = true;
      notifications.success("Manifest Saved", "Manifest successfully saved.");
    }
    catch(ex) {
      notifications.error("Save Manifest", "Failed to save manifest.", ex);
    }
    finally {
      this.saving = false;
    }
    if(saved){
      await this.reloadManifest();
    }
  }

  async reset() {
    await this.reloadManifest();
    this.loadingComplete = false;
  }
}
